export enum IconType {
    GitHub = "GitHub",
    LinkedIn = "LinkedIn",
    Twitter = "Twitter",
    Medium = "Medium",
    CodeSandbox = "CodeSandbox",
}
